// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"styles_audioPlayer__aEUts"};